import React from 'react';
import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';

export default function ModalMobileApp(props) {
  const app = props.model;
  const esEdicion = !!app?.id;

  return (
    <Modal
      title="Aplicación móvil"
      model={app}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      entity="oauth/app"
    >
      <TextField
        label="Código"
        type="text"
        name="code"
        margin="normal"
        fullWidth
        defaultValue={!!app ? app.code : ''}
        disabled={esEdicion}
        required
      />
      <TextField
        label="Descripción"
        type="text"
        name="description"
        margin="normal"
        fullWidth
        defaultValue={!!app ? app.description : ''}
        required
      />
    </Modal>
  );
}
